import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled, { css } from 'styled-components';
import { MessagePreviewFragment } from '../../graphql/types';
import { AQUAMARINE, BLACK, EXOS_GRAY } from '../../theme';
import Text, { TextColor, TextKind } from '../reusable/Text';
import { TextLineClamp } from '../reusable/TextLineClamp';

const FIT_URL = 'https://fit.teamexos.com/';
const FIT_SCHEME_URL = 'exosfit://';
const UnfurlContainer = styled.div<{
  $isSentMessage?: boolean;
}>`
  display: flex;
  margin-bottom: 4px;
  ${({ $isSentMessage }) => {
    if ($isSentMessage) {
      return css`
        justify-content: flex-end;
      `;
    } else {
      return '';
    }
  }}
`;

const UnfurlWrapper = styled.a<{
  $isSentMessage?: boolean;
}>`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  text-decoration: none;
  overflow: hidden;
  ${({ $isSentMessage }) => {
    if ($isSentMessage) {
      return css`
        background: ${AQUAMARINE};
      `;
    } else {
      return css`
        background: ${EXOS_GRAY};
      `;
    }
  }}
`;

const Image = styled.img`
  width: 100%;
`;

const BottomContainer = styled.div`
  display: flex;
  padding: 16px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ArrowIcon = styled(FontAwesomeIcon)`
  margin-left: 8px;
  align-self: flex-end;
  color: ${BLACK};
`;

export const Unfurl: React.FC<{
  preview: MessagePreviewFragment;
  isSentMessage?: boolean;
  onLinkClick?: (url: string) => void;
}> = ({ preview, isSentMessage, onLinkClick }) => {
  const { title, description, url, image } = preview;

  const isInternalLink =
    url && (url.includes(FIT_URL) || url.includes(FIT_SCHEME_URL));

  const unfurlDescription = isInternalLink ? description : url;
  const hasImage = image && image.id && image.basePath;
  const handleLinkClick = () => {
    if (onLinkClick) {
      onLinkClick(url);
    }
  };
  return (
    <UnfurlContainer $isSentMessage={isSentMessage}>
      <UnfurlWrapper
        href={url}
        target="_blank"
        onClick={handleLinkClick}
        $isSentMessage={isSentMessage}
      >
        {hasImage && (
          <Image
            role="img"
            alt=""
            src={`${image?.basePath}/${image?.id}/305x177.jpg`}
          />
        )}
        <BottomContainer>
          <TextContainer>
            <TextLineClamp>
              <Text kind={TextKind.TitleXs} testId="unfurl-title">
                {title}
              </Text>
            </TextLineClamp>
            <TextLineClamp>
              <Text
                kind={TextKind.BodyS}
                testId="unfurl-description"
                color={TextColor.Primary}
              >
                {unfurlDescription}
              </Text>
            </TextLineClamp>
          </TextContainer>
          <ArrowIcon icon={faArrowRight} />
        </BottomContainer>
      </UnfurlWrapper>
    </UnfurlContainer>
  );
};
